<template>
  <modal
    id="assessment-warning"
    :size="'md'"
    :confirm-text="'Exit'"
    confirm-class="btn-default pull-left"
    :show-exit="true"
    :show-close="false"
    @confirm="completeAssessment"
  >
    <template v-slot:title><h1>Assessment Not Complete</h1></template>
    <template v-slot:body>
      <strong>WARNING.</strong> Your assessment is currently in-progress. If you choose to leave,
      the assessment will be marked as complete and you cannot re-enter.
    </template>
  </modal>
</template>

<script>
  import Modal from '@shared/Modal.vue';
  export default {
    components: {
      Modal,
    },

    methods: {
      async completeAssessment() {
        this.$emit('confirm', true);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .box {
    background: #eef6f9;
  }
</style>
